const NavConfig = function (element) {
    const config = {};

    element = element || document;
    const configDiv = element.querySelector('.js-nav-config');

    if (!configDiv) {
        return;
    }

    config.anonymousMessage = configDiv.dataset.anonText || '';
    config.loggedinMessage = configDiv.dataset.loggedinText || '';

    config.showName = configDiv.dataset.showName === 'yes';
    config.showLogout = configDiv.dataset.showLogout === 'yes';

    this.getAnonymousMessage = () => {
        return config.anonymousMessage;
    };

    this.getLoggedinMessage = () => {
        return config.loggedinMessage;
    };

    this.getShowName = () => {
        return config.showName;
    };

    this.getShowLogout = () => {
        return config.showLogout;
    };    
};

export default NavConfig;


// WEBPACK FOOTER //
// ./src/nams2020/webparts/Header/NavConfig.js